module.exports = __webpack_public_path__ + "static/silas-baisch-K785Da4A_JA-unsplash-440d9ff1d9c7d8d0a20896dfdbf7b9c1.jpg";